import { createFileRoute, Outlet } from '@tanstack/react-router';
import { DashboardLayoutFrame } from '@/components/layout/DashboardLayoutFrame';

export const Route = createFileRoute('/_authed/$orgSlug')({
  component: OrgLayout,
});

function OrgLayout() {
  return (
    <DashboardLayoutFrame>
      <Outlet />
    </DashboardLayoutFrame>
  );
}
